

import React from 'react';
import RashtriyaEktaDivas from 'views/RashtriyaEktaDivas';

const RentalPage = () => {
  return <RashtriyaEktaDivas />;
};

export default RentalPage;